// extracted by mini-css-extract-plugin
export default {"equilateral":"ShapeWrapper_equilateral__PeelT","square":"ShapeWrapper_square__qJOKU","inner":"ShapeWrapper_inner__VLxf2","circle":"ShapeWrapper_circle__Fgkh5"};